import styled from "styled-components";

const ImageDetail = styled.div`
  font-size: 22px;
  text-transform: lowercase;
  font-weight: 800;
  margin-top: 10px;

  @media (max-width: 1599px) {
    font-size: 20px;
  }
  @media (max-width: 1199px) {
    font-size: 16px;
  }
  @media (max-width: 575px) {
    line-height: normal;
  }
`;
export default ImageDetail;
